export default __webpack_public_path__ + "static/media/saint_aubin12.017b1c67.jpg";